import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { DrawerIcon } from "shared/icons"

const DrawerToggle = ({ className = "", isOpen, toggleDrawer }) => (
  <button
    aria-label={`${isOpen ? "hide" : "show"} submission access overview`}
    className={clsx(className, "flex justify-center items-center h-9 w-9 border border-lightgray-3 rounded-md bg-white cursor-pointer")}
    onClickCapture={toggleDrawer}
  >
    <DrawerIcon isOpen={isOpen} className="shrink-0 h-5 w-5" ariaHidden />
  </button>
)

DrawerToggle.propTypes = {
  className: types.string,
  isOpen: types.bool.isRequired,
  toggleDrawer: types.func.isRequired,
}

export default DrawerToggle
